module.exports = __webpack_public_path__ + "static/1-504f67bee35e556fc0e92ce732b37e44.gif";